module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture1-ec5a2a8d238646084fa527bdc0277e5d.jpg";